export const changePassword = {
    title: '비밀번호 변경',
    oldPasswordLabel: '기존 비밀번호',
    newPasswordLabel: '새 비밀번호',
    confirmPasswordLabel: '새 비밀번호를 재입력하세요',
    password: '비밀번호',
    save: '변경 사항을 저장하기',
    cancel: '취소',
};
